import { ChordInScaleEdit } from "../models/wasm.model";

/**
 * For demo purposes
 */
export const C_MAJ_TRIAD: ChordInScaleEdit = {
  chord_type: "MajorTriad",
  root_note: {
    note_id: "C",
    note_name: "C",
    interval: {
      chord_int: "Tonic",
      scale_degree: "Tonic",
    },
  },
  bass_note_id: 'C',
  notes: [
    {
      note_id: "C",
      note_name: "C",
      interval: {
        chord_int: "Tonic",
        scale_degree: "Tonic",
      },
    },
    {
      note_id: "E",
      note_name: "E",
      interval: {
        chord_int: "MajorThird",
        scale_degree: "MajorThird",
      },
    },
    {
      note_id: "G",
      note_name: "G",
      interval: {
        chord_int: "PerfectFifth",
        scale_degree: "PerfectFifth",
      },
    },
  ],
  silent_notes: [],
  variant: "Standard",
};
